import { AuthService } from "@js/services/AuthService";
import { CaseService } from "@js/services/CaseService";
import { SharedSearchResultsService } from "@js/services/Deal/SharedSearchResultsService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { SharedDataService } from "@js/services/SharedDataService";
import {
  ApplicationUser,
  ApplicationUserCrudClient,
  BrickflowEventLogClient,
  BridgingDeal,
  BridgingDealClient,
  BridgingLenderResultSummaryDTO,
  BridgingSearchResultsResponse,
  Case,
  CaseAccessLevelEnum,
  CaseLender,
  CaseLenderStateEnum,
  CaseStatusEnum,
  Client,
  DealClient,
  DealClientClient,
  DealLender,
  DealLenderClient,
  EventLogEnum,
  LenderClient,
  LenderProductPairDTO,
  LenderResult,
  MakeReferralMessageRequest,
  Organisation,
  OrganisationClient,
  OrganisationLinkClient,
  OwnOrPurchaseEnum,
  PreviousDevelopmentsEnum,
  ProductClient,
  ProductFamilyEnum,
  ProductTypeEnum,
  SaveAsSearchRequest,
  SaveBridgingSearchRequest,
  ShareDealDTO,
  SortByEnum,
  StaticDataClient,
  UpdateBridgingSearchGetResultResponse,
  UserClient,
  BridgingSearchClient,
  ShortlistRequest,
} from "@src/apis/ModularClient";
import ProductHelper from "@js/helpers/ProductHelper";
import DealHelper from "@js/helpers/DealHelper";
import { BridgingPersonalGuaranteeLevelEnum } from "@js/models/enum/BridgingPersonalGuaranteeLevelEnum";
import { MaxHouseSalePriceEnum } from "@js/models/enum/MaxHouseSalePriceEnum";
import { MaxFlatUnitPriceEnum } from "@js/models/enum/MaxFlatUnitPriceEnum";
import { MaxSqFtSalePriceEnum } from "@js/models/enum/MaxSqFtSalePriceEnum";
import { OrganisationService } from "@js/services/OrganisationService";
import { IndexService } from "@js/services/IndexService";
import { DealLenderService } from "@js/services/Deal/DealLenderService";
import { BaseLenderResultsScreenController } from "@js/controllers/BaseLenderResultsScreenController";

declare const window: Window & { dataLayer: any[] };

export class BridgingLenderResultScreenController extends BaseLenderResultsScreenController<BridgingDeal> {
  searchPanelForm: ng.IFormController;

  // tourState: any = {
  //   tourStep: 1,
  //   tourTotalSteps: 0,
  // };
  guidanceCheckbox: boolean = true;
  // tourEnabled: boolean = false;

  totalLender: number = 0;
  isSearch: boolean = true;

  debug1: boolean = false;

  summarySearchResults: BridgingLenderResultSummaryDTO[];
  initialSummarySearchResults: BridgingLenderResultSummaryDTO[];
  productLastVerifiedDates = {};
  offer: BridgingLenderResultSummaryDTO;
  comparisonList: BridgingLenderResultSummaryDTO[] = [];

  selectedResult: LenderResult;

  dealClientUniqueRef: string = null;
  dealUniqueRef: string = null;
  hideCaseCreation: boolean = false;

  loanLabel: string;
  warningOff: boolean = false;
  currentCase: Case;
  productResultList: number;
  productId: number;
  caseLenders: CaseLender[];
  dealLenders: DealLender[];
  caseLendersNotInResults: DealLender[];
  filterLenderNames: string[] = [];

  sliderShown: boolean;
  searchNameCache: string;

  notifyBorrower: boolean = true;

  showProductNote: boolean = false;
  productNote: string;

  savePressed: boolean = false;

  //Capture name and email address & send results to unregistered searcher
  newUser: ApplicationUser = {} as ApplicationUser;
  error: string = "";

  // Flag to disable or enable the Save as button depending on the click.
  isClicked: boolean = false;
  showContactBrokerModal: boolean = false;

  //For admins accessing client accounts
  //clientUsernameBeingAccessed: string;
  toggleEditSearchName: boolean = false;
  // isBlankSearch: boolean = false;
  showActionPanel: boolean = false;

  isLoggingOut: boolean = false;

  clientId: string = null;
  appName: string;
  isSaveorSaveAsClicked: boolean = false;
  noOfShortlistAllowed: number = 5;
  showMsgToAdminOrBroker: boolean = false;
  ShowdeleteSearch: boolean = false;
  isProceedClicked: boolean = false;

  isResultScreen: boolean = true;
  tempLoanCriteria = null;
  showFilters: boolean = false;
  isFilterUpdate: boolean = false;
  showSortBy: boolean = false;

  showContactLender: boolean = false;
  shareForm: ng.IFormController;

  lenderEmail: string;
  shareEmailSubject: string;
  dataLoading: boolean = false;

  orgName: string;
  orgNameUnderscore: string;
  brokerDetail: string = "";
  brokerageOrgFilename: string = "Brickflow";
  showMessageToborrower: boolean = false;
  borrowerMessage: string = "";
  user: ApplicationUser;
  moveContactBrokerBtnInMiddle: boolean = false;
  isBridging: boolean = true;
  isMaximumLoanRequired: boolean = false;

  carouselData: string[] = [];
  numberOfPreviousDevelopmentsOptions = [];

  personalGuaranteeLevelOptions = [];
  maxHouseSalePriceOptions = [];
  maxFlatUnitPriceOptions = [];
  maxSqFtSalePriceOptions = [];
  maxPercCommercialForMixedUseOptions = [];
  locationOptions = [];
  valuationMethodOptions = [];
  maxCommercialFloorspaceOptions = [];
  currentUseOptions = [];

  personalGuaranteeLevel = null;
  maxHouseSalesPrice = null;
  maxFlatUnitPrice = null;
  maxSqFtSalePrice = null;
  maxPercCommercialForMixedUse = null;
  maxSqFtSalePriceFlats = null;
  previousDevelopments = null;

  hasSearchChanged: boolean = false;
  inActiveDealLender: number = 0;
  hasAccessToDeal: boolean = true;
  tempLoanRequired: number = null;

  showEligibility: boolean = false;
  showLenderSnapshot: boolean = false;
  showLenderNamesAndLogosOverride: boolean = false;
  isAssigned = false;
  userRole: string = null;

  dealProductTypeDisplayText: string;

  showEnterpriseRegistrationModal: boolean = false;
  projectName: string = "";
  registrationForm: ng.IFormController;
  emailExistsError: boolean = false;

  snapshotNewSearch: boolean = false;
  showPostcodeErrorMessage: boolean = false;
  postcodeErrorMsg: string;
  isPostcodeChange: boolean = false;

  noAccessToDealMsg: string;

  //This boolean is used in the shareedmodal.html for all the deals
  isDeal: boolean = true;

  //LenderReferralSearch
  isLenderReferredSearch: boolean = false;

  hasResultsProcessed: boolean = false;

  //SaveAs functionality
  reloadSearch: boolean = false;

  //Enterprise journey
  password: string = null;

  // Previously shortlisted/submitted lenders which are not visible on current results because of criteria change
  HiddenDealLenderList: DealLender[] = [];
  showExportOptions: boolean = false;

  //Confirm phone number for new client, when they register through enterprise journey from results page
  showClientPhoneNumberConfirmationModal: boolean = false;
  clientUpdatedContact: string;
  confirmClientPhoneNumberForm: ng.IFormController;
  clientUpdatedContactErrorMessage: string;

  // Logging in/resetting password
  isLoginError: boolean = false;
  isResetPasswordSubmitted: boolean = false;
  registrationLoginError: string = null;

  filterProperties = [
    "f_IsFirstTimeDeveloper",
    "f_NumberOfPreviousDevelopments",
    "f_IsPersonalName",
    "f_IsOffshoreCompany",
    "f_IsMainShareholderOverseas",
    "f_PersonalGuaranteeMax",
    "f_HasAdverseCredit",
    "f_IsBelowMarketValue",
    "f_IsAutomatedValuationModel",
    "f_IsAuctionPurchase",
    "f_ValuationMethod",
    "f_MaxCommercialFloorspace",
    "f_IsShariaLoan",
    "f_IsGradeOneListed",
    "f_IsGradeTwoListed",
    "f_MaxHouseSalesPrice",
    "f_MaxFlatUnitPrice",
    "f_MaxNumberOfUnits",
    "f_MaxSqFtSalePrice",
    "f_MaxSqFtSalePriceFlats",
    "f_IsChargeOnAdditionalProperty",
    "f_IsFixedRate",
    "f_IsReBridge",
    "f_IsServicedInterest",
    "f_IsTitleInsurance",
    "f_IsIndemnityInsurance",
    "f_IsRetypedValuation",
    "f_IsTimberFrameConstruction",
    "f_IsConcreteConstruction",
  ];

  static $inject = [
    "$route",
    "$routeParams",
    "$scope",
    "$rootScope",
    "$location",
    "$cookies",
    "UserClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "CaseService",
    "AuthService",
    "RoleService",
    "OrganisationClient",
    "SelectListService",
    "BridgingDealClient",
    "DealClient",
    "LenderClient",
    "DealLenderClient",
    "ProductClient",
    "BrickflowEventLogClient",
    "SharedSearchResultsService",
    "DealClientClient",
    "OrganisationLinkClient",
    "OrganisationService",
    "StaticDataClient",
    "SharedDataService",
    "BridgingSearchClient",
    "DealLenderService",
  ];

  constructor(
    private $route: ng.route.IRouteService,
    private $routeParams: ng.route.IRouteParamsService,
    private $scope: ng.IScope,
    $rootScope: ng.IRootScopeService,
    $location: ng.ILocationService,
    private $cookies: ng.cookies.ICookiesService,
    userClient: UserClient,
    applicationUserCrudClient: ApplicationUserCrudClient,
    indexService: IndexService,
    private $caseService: CaseService, // Fixed case inconsistency here
    private $auth: AuthService,
    roleService: RoleService,
    organisationClient: OrganisationClient,
    private selectListService: SelectListService,
    private bridgingDealClient: BridgingDealClient,
    dealClient: DealClient,
    lenderClient: LenderClient,
    private dealLenderClient: DealLenderClient,
    private productClient: ProductClient,
    eventLogClient: BrickflowEventLogClient,
    private sharedSearchResultsService: SharedSearchResultsService,
    private dealClientClient: DealClientClient,
    organisationLinkClient: OrganisationLinkClient,
    private organisationService: OrganisationService,
    private staticDataClient: StaticDataClient,
    sharedDataService: SharedDataService,
    private bridgingSearchClient: BridgingSearchClient,
    private dealLenderService: DealLenderService,
  ) {
    super(
      $rootScope,
      $location,
      applicationUserCrudClient,
      indexService,
      roleService,
      lenderClient,
      userClient,
      sharedDataService,
      organisationClient,
      eventLogClient,
      organisationLinkClient,
      dealClient,
    );

    if (this.$routeParams.SearchId && $location.search().source === "email") {
      dealClient.getDealStatus(this.$routeParams.SearchId).then((status) => {
        if (status !== undefined && status !== null && status != CaseStatusEnum.Search) {
          $location.path(`/bridgingcasedashboard/${this.$routeParams.SearchId}`);
          $location.search("source", null); // Remove the query param
        } else {
          $location.search("source", null); // Still remove it if you don't need it anymore
        }
      });
    } else {
      this.init();
    }
  }

  init() {
    if (this.$location.path().startsWith("/bridgingshortlistmore")) {
      this.isShortlistingMore = true;
    }

    this.staticDataClient.getShowBridgingEligibility().then((response) => {
      this.showEligibility = response;
    });

    this.staticDataClient.getShowBridgingLenderSnapshot().then((response) => {
      this.showLenderSnapshot = response;
    });

    if (this.$routeParams.SearchId) {
      if (/^\d+$/.test(this.$routeParams.SearchId)) {
        // Treat the reference as an ID (e.g., fetch data using the ID)
        this.searchid = Number(this.$routeParams.SearchId);
      } else {
        // Treat the reference as a unique string (e.g., fetch data using the string)
        this.dealUniqueRef = this.$routeParams.SearchId;
      }
    } /*else {
                this.$caseService.updateTubeMap(null);
      }*/

    if (this.$routeParams.dealclientuniqueref) {
      this.dealClientUniqueRef = this.$routeParams.dealclientuniqueref;
    }

    if (window.self == window.top && this.$cookies.get("access_token")) {
      //This block is to navigate a broker to userdashboard when they do not have a license.
      if (sessionStorage.getItem("isValidLicense") == "false") {
        this.$auth.clearSelectedNavMenuAndFilterStorageData();
        this.$location.path("/userdashboard");
      }

      this.isLoggedInUser = true;
      this.loadingData = true;
      this.organisationClient
        .getOrganisation()
        .then((organisation) => {
          if (organisation) {
            if (!organisation.isBrickflow) {
              //Getting organisation phone number to display on the screen with other text, when there are no results.
              this.clientOrganisationPhoneNumber = organisation.phoneNumber;
            }
            this.orgCode = organisation.isWhiteLabelled ? organisation.organisationCode : "";
            this.showLenderNamesAndLogosOverride = organisation.showLenderNames ?? false;

            if (organisation.isWhiteLabelled) {
              this.orgName = organisation.name.replace(/ /g, "_");
            } else {
              this.orgName = "Brickflow";
            }
          }
        })
        .catch((error) => {
          this.loadingData = false;
        })
        .finally(() => {
          //this.loadingData = false;
        });
    } else {
      if (window.self == window.top) {
        //this.userRole = sessionStorage.getItem('userRole');
        this.isClient = this.userRole == "borrower";
        this.orgCode = this.$cookies.get("org_code");
        //this.clientId = sessionStorage.getItem('clientId');
        this.getSearchCriteriaAndResults();
      } else {
        this.orgCode = location.pathname.replace("/", "");
        this.guidanceCheckbox = false;
        Promise.all([
          this.organisationService.getData("userRole").then((userRole) => {
            if (userRole) {
              this.userRole = userRole;
              this.isClient = this.userRole == "borrower";
            }
          }) /*,
                        this.organisationService.getData('clientId').then(clientId => {
                            if (clientId) {
                                this.clientId = clientId;
                            }
                        })*/,
          //Try get session storage if running in iframe before getting results
          this.organisationService.getData("newSearch").then((newSearch) => {
            if (newSearch) {
              this.snapshotNewSearch = Boolean(newSearch) == true;
            }
          }),
        ])
          .then(() => {
            this.orgCode = location.pathname.replace("/", "");
            this.organisationService.sendDataToParent("newSearch", "false");
            this.getSearchCriteriaAndResults();
          })
          .catch((error) => {
            // One or both of the promises were rejected, handle the error
            console.error("Failed to get user data: ", error);
          });
      }
    }

    if (window.self == window.top) {
      // let cookieTourStep = this.$cookies.get("tourStep");
      // if (cookieTourStep) {
      //   this.tourState.tourStep = cookieTourStep;
      // }

      //if user is logged in, get profile
      if (this.$cookies.get("access_token")) {
        this.initialiseProfileData();
      } else {
        this.isClient = true; // if the user isn't logged in then this is the enterprise journey and should be treated as a borrower/client
      }

      // this.updateGuidanceState();

      // $rootScope.$on("guidanceStateChanged", (event: ng.IAngularEvent) => {
      //   this.updateGuidanceState();
      // });

      let logoutUnregister = this.$rootScope.$on("logout", (event: ng.IAngularEvent) => {
        this.isLoggingOut = true;
      });

      this.$scope.$on("$destroy", logoutUnregister);

      // $rootScope.$on("nextTour", (event: ng.IAngularEvent) => {
      //   this.tourNext();
      // });
      // $rootScope.$on("backTour", (event: ng.IAngularEvent) => {
      //   this.tourBack();
      // });
      // $rootScope.$on("skipTour", (event: ng.IAngularEvent) => {
      //   this.tourSkip();
      // });
    }

    this.getAppName();

    this.numberOfPreviousDevelopmentsOptions = this.selectListService.GetNumberOfPreviousDevelopmentsForBridging();
    this.personalGuaranteeLevelOptions = this.selectListService.GetBridgingPersonalGuaranteeLevels();
    this.maxHouseSalePriceOptions = this.selectListService.GetMaxHouseSalePrices();
    this.maxFlatUnitPriceOptions = this.selectListService.GetMaxFlatUnitPrices();
    this.maxSqFtSalePriceOptions = this.selectListService.GetMaxSqFtSalePrices();
    this.locationOptions = this.selectListService.GetLocations();
    this.valuationMethodOptions = this.selectListService.GetValuationMethodOptions();
    this.maxCommercialFloorspaceOptions = this.selectListService.GetMaxCommercialFloorspaceOptions();
  }

  getRequiredRoles(isCaseDashboard: boolean) {
    if (isCaseDashboard) return `['Admin', 'Client', 'Broker', 'Introducer']`;
    return `['Admin', 'Client', 'Broker', 'Introducer', 'Lender']`;
  }

  onPersonalGuaranteeLevelOptionsChange(e: BridgingPersonalGuaranteeLevelEnum) {
    switch (e) {
      case BridgingPersonalGuaranteeLevelEnum.None:
        this.loanCriteria.f_PersonalGuaranteeMin = 0.0;
        this.loanCriteria.f_PersonalGuaranteeMax = 0.0;
        break;
      case BridgingPersonalGuaranteeLevelEnum.OneToTwentyFivePercent:
        this.loanCriteria.f_PersonalGuaranteeMin = 0.01;
        this.loanCriteria.f_PersonalGuaranteeMax = 0.25;
        break;
      case BridgingPersonalGuaranteeLevelEnum.TwentySixToFiftyPercent:
        this.loanCriteria.f_PersonalGuaranteeMin = 0.26;
        this.loanCriteria.f_PersonalGuaranteeMax = 0.5;
        break;
      case BridgingPersonalGuaranteeLevelEnum.FiftyOneToOneHundredPercent:
        this.loanCriteria.f_PersonalGuaranteeMin = 0.51;
        this.loanCriteria.f_PersonalGuaranteeMax = 1.0;
        break;
      default:
        this.loanCriteria.f_PersonalGuaranteeMin = null;
        this.loanCriteria.f_PersonalGuaranteeMax = null;
        break;
    }
  }

  getPersonalGuaranteeLevelOptions() {
    return this.sharedSearchResultsService.getPersonalGuaranteeLevelOptions(
      this.tempLoanCriteria.f_PersonalGuaranteeMax,
    );
  }

  getPreviousDevelopments() {
    var value = null;
    switch (this.tempLoanCriteria.f_NumberOfPreviousDevelopments) {
      case 0:
        value = PreviousDevelopmentsEnum.None;
        break;
      case 5:
        value = PreviousDevelopmentsEnum.OneOrTwo;
        break;
      case 6:
        value = PreviousDevelopmentsEnum.ThreeOrMore;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  onMaxHouseSalesPriceChange(e: MaxHouseSalePriceEnum) {
    switch (e) {
      case MaxHouseSalePriceEnum.UpTo1Million:
        this.loanCriteria.f_MaxHouseSalesPrice = 1000000;
        break;
      case MaxHouseSalePriceEnum.UpTo2Million:
        this.loanCriteria.f_MaxHouseSalesPrice = 2000000;
        break;
      case MaxHouseSalePriceEnum.UpTo5Million:
        this.loanCriteria.f_MaxHouseSalesPrice = 5000000;
        break;
      case MaxHouseSalePriceEnum.NoMax:
        this.loanCriteria.f_MaxHouseSalesPrice = -999;
        break;
      default:
        this.loanCriteria.f_MaxHouseSalesPrice = null;
        break;
    }
  }

  getMaxHouseSalesPrice() {
    var value = null;
    switch (this.tempLoanCriteria.f_MaxHouseSalesPrice) {
      case 1000000:
        value = MaxHouseSalePriceEnum.UpTo1Million;
        break;
      case 2000000:
        value = MaxHouseSalePriceEnum.UpTo2Million;
        break;
      case 5000000:
        value = MaxHouseSalePriceEnum.UpTo5Million;
        break;
      case -999:
        value = MaxHouseSalePriceEnum.NoMax;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  onMaxFlatUnitPriceChange(e: MaxFlatUnitPriceEnum) {
    switch (e) {
      case MaxFlatUnitPriceEnum.UpTo1Million:
        this.loanCriteria.f_MaxFlatUnitPrice = 1000000;
        break;
      case MaxFlatUnitPriceEnum.UpTo2Million:
        this.loanCriteria.f_MaxFlatUnitPrice = 2000000;
        break;
      case MaxFlatUnitPriceEnum.UpTo3Million:
        this.loanCriteria.f_MaxFlatUnitPrice = 3000000;
        break;
      case MaxFlatUnitPriceEnum.NoMax:
        this.loanCriteria.f_MaxFlatUnitPrice = -999;
        break;
      default:
        this.loanCriteria.f_MaxFlatUnitPrice = null;
        break;
    }
  }

  getMaxFlatUnitPrice() {
    var value = null;
    switch (this.tempLoanCriteria.f_MaxFlatUnitPrice) {
      case 1000000:
        value = MaxFlatUnitPriceEnum.UpTo1Million;
        break;
      case 2000000:
        value = MaxFlatUnitPriceEnum.UpTo2Million;
        break;
      case 3000000:
        value = MaxFlatUnitPriceEnum.UpTo3Million;
        break;
      case -999:
        value = MaxFlatUnitPriceEnum.NoMax;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  onMaxSqFtSalePriceChange(e: MaxSqFtSalePriceEnum) {
    switch (e) {
      case MaxSqFtSalePriceEnum.UpTo850:
        this.loanCriteria.f_MaxSqFtSalePrice = 850;
        break;
      case MaxSqFtSalePriceEnum.UpTo1000:
        this.loanCriteria.f_MaxSqFtSalePrice = 1000;
        break;
      case MaxSqFtSalePriceEnum.UpTo1500:
        this.loanCriteria.f_MaxSqFtSalePrice = 1500;
        break;
      case MaxSqFtSalePriceEnum.NoMax:
        this.loanCriteria.f_MaxSqFtSalePrice = -999;
        break;
      default:
        this.loanCriteria.f_MaxSqFtSalePrice = null;
        break;
    }
  }

  onMaxSqFtFlatsSalePriceChange(e: MaxSqFtSalePriceEnum) {
    switch (e) {
      case MaxSqFtSalePriceEnum.UpTo850:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = 850;
        break;
      case MaxSqFtSalePriceEnum.UpTo1000:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = 1000;
        break;
      case MaxSqFtSalePriceEnum.UpTo1500:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = 1500;
        break;
      case MaxSqFtSalePriceEnum.NoMax:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = -999;
        break;
      default:
        this.loanCriteria.f_MaxSqFtSalePriceFlats = null;
        break;
    }
  }

  getMaxSqFtSalePrice() {
    var value = null;
    switch (this.tempLoanCriteria.f_MaxSqFtSalePrice) {
      case 850:
        value = MaxSqFtSalePriceEnum.UpTo850;
        break;
      case 1000:
        value = MaxSqFtSalePriceEnum.UpTo1000;
        break;
      case 1500:
        value = MaxSqFtSalePriceEnum.UpTo1500;
        break;
      case -999:
        value = MaxSqFtSalePriceEnum.NoMax;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  getMaxSqFtSalePriceFlats() {
    var value = null;
    switch (this.tempLoanCriteria.f_MaxSqFtSalePriceFlats) {
      case 850:
        value = MaxSqFtSalePriceEnum.UpTo850;
        break;
      case 1000:
        value = MaxSqFtSalePriceEnum.UpTo1000;
        break;
      case 1500:
        value = MaxSqFtSalePriceEnum.UpTo1500;
        break;
      case -999:
        value = MaxSqFtSalePriceEnum.NoMax;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  clearSelected() {
    if (this.isShortlistingMore) {
      this.comparisonList = this.comparisonList.filter((item) =>
        this.summarySearchResults.some((result) => result.productID == item.productID),
      );

      const dealLenders = this.initialSummarySearchResults.filter((result) => result.isDealLender);

      dealLenders.forEach((dealLender) => {
        if (!this.comparisonList.some((item) => item.productID === dealLender.productID)) {
          this.comparisonList.push(dealLender);
        }
      });
    } else {
      this.comparisonList = this.comparisonList.filter((item) =>
        this.summarySearchResults.some((result) => result.productID == item.productID),
      );
    }
  }

  applyFilters() {
    this.loadingData = true;
    this.showFilters = false;
    this.isFilterUpdate = true;

    if (this.loanCriteria.f_IsFirstTimeDeveloper) {
      this.loanCriteria.f_NumberOfPreviousDevelopments = null;
    }

    this.updateCriteriaAndGetResults(false);
  }

  doClearClientFilters() {
    event.stopPropagation();
    this.loanCriteria.f_IsFirstTimeDeveloper = null;
    this.loanCriteria.f_NumberOfPreviousDevelopments = null;
    this.loanCriteria.f_IsPersonalName = null;
    this.loanCriteria.f_IsOffshoreCompany = null;
    this.loanCriteria.f_IsMainShareholderOverseas = null;

    this.loanCriteria.f_PersonalGuaranteeLevel = null;
    this.personalGuaranteeLevel = null;
    this.previousDevelopments = null;

    this.loanCriteria.f_PersonalGuaranteeMin = null;
    this.loanCriteria.f_PersonalGuaranteeMax = null;
    this.loanCriteria.f_HasAdverseCredit = null;
    this.loanCriteria.f_IsBelowMarketValue = null;
    this.loanCriteria.f_IsAutomatedValuationModel = null;
    this.loanCriteria.f_IsAuctionPurchase = null;
    this.loanCriteria.f_ValuationMethod = null;
  }

  showClearForClientFilters() {
    if (
      this.loanCriteria.f_IsFirstTimeDeveloper != null ||
      this.loanCriteria.f_NumberOfPreviousDevelopments != null ||
      this.loanCriteria.f_IsPersonalName != null ||
      this.loanCriteria.f_IsOffshoreCompany != null ||
      this.loanCriteria.f_IsMainShareholderOverseas != null ||
      this.loanCriteria.f_PersonalGuaranteeLevel != null ||
      this.loanCriteria.f_PersonalGuaranteeMin != null ||
      this.loanCriteria.f_PersonalGuaranteeMax != null ||
      this.loanCriteria.f_HasAdverseCredit != null ||
      this.loanCriteria.f_IsBelowMarketValue != null ||
      this.loanCriteria.f_IsAutomatedValuationModel != null ||
      this.loanCriteria.f_IsAuctionPurchase != null ||
      this.loanCriteria.f_ValuationMethod != null
    ) {
      return true;
    } else {
      return false;
    }
  }

  toggleCheckbox(variableName) {
    if (this.loanCriteria[variableName] === null || this.loanCriteria[variableName] === false) {
      this.loanCriteria[variableName] = true;
    } else {
      this.loanCriteria[variableName] = null;
    }
  }

  doClearPropertyFilters() {
    event.stopPropagation();
    //this.loanCriteria.f_IsAirRights = null;
    //this.loanCriteria.f_IsModular = null;
    //this.loanCriteria.f_IsPermittedDevelopmentScheme = null;
    this.loanCriteria.f_IsGradeOneListed = null;
    this.loanCriteria.f_IsGradeTwoListed = null;
    this.loanCriteria.f_MaxHouseSalesPrice = null;
    this.loanCriteria.f_MaxFlatUnitPrice = null;
    this.loanCriteria.f_MaxNumberOfUnits = null;
    this.loanCriteria.f_MaxPercCommercialForMixedUse = null;
    this.loanCriteria.f_MaxSqFtSalePrice = null;
    this.loanCriteria.f_MaxSqFtSalePriceFlats = null;

    //this.loanCriteria.f_IsWorkStarted = null;
    this.maxHouseSalesPrice = null;
    this.maxFlatUnitPrice = null;
    this.maxSqFtSalePrice = null;
    this.maxSqFtSalePriceFlats = null;
    this.loanCriteria.f_IsTimberFrameConstruction = null;
    this.loanCriteria.f_IsConcreteConstruction = null;
    this.loanCriteria.f_MaxCommercialFloorspace = null;
  }

  showClearForPropertyFilters() {
    if (
      this.loanCriteria.f_IsGradeOneListed != null ||
      this.loanCriteria.f_IsGradeTwoListed != null ||
      this.loanCriteria.f_MaxHouseSalesPrice != null ||
      this.loanCriteria.f_MaxFlatUnitPrice != null ||
      this.loanCriteria.f_MaxNumberOfUnits != null ||
      this.loanCriteria.f_MaxSqFtSalePrice != null ||
      this.loanCriteria.f_MaxSqFtSalePriceFlats != null ||
      this.loanCriteria.f_IsTimberFrameConstruction != null ||
      this.loanCriteria.f_IsConcreteConstruction != null ||
      this.loanCriteria.f_MaxCommercialFloorspace != null
    ) {
      return true;
    } else {
      return false;
    }
  }

  doClearFinanceFilters() {
    event.stopPropagation();
    this.loanCriteria.f_IsChargeOnAdditionalProperty = null;
    this.loanCriteria.f_IsFixedRate = null;
    this.loanCriteria.f_IsShariaLoan = null;
    this.loanCriteria.f_IsRetypedValuation = null;
    this.loanCriteria.f_IsIndemnityInsurance = null;
    this.loanCriteria.f_IsTitleInsurance = null;
    this.loanCriteria.f_IsServicedInterest = null;
    this.loanCriteria.f_IsReBridge = null;
  }

  showClearForFinanceFilters() {
    if (
      this.loanCriteria.f_IsChargeOnAdditionalProperty != null ||
      this.loanCriteria.f_IsFixedRate != null ||
      this.loanCriteria.f_IsRetypedValuation != null ||
      this.loanCriteria.f_IsIndemnityInsurance != null ||
      this.loanCriteria.f_IsTitleInsurance != null ||
      this.loanCriteria.f_IsServicedInterest != null ||
      this.loanCriteria.f_IsReBridge != null ||
      this.loanCriteria.f_IsShariaLoan != null
    ) {
      return true;
    } else {
      return false;
    }
  }

  debugSearch() {
    const stringJSON = JSON.stringify(this.loanCriteria);
    navigator.clipboard
      .writeText(stringJSON)
      .then()
      .catch((e) => console.log(e));
  }

  onClickFilterCancel() {
    this.filterProperties.forEach((e) => (this.loanCriteria[e] = this.tempLoanCriteria[e]));

    this.personalGuaranteeLevel = null;
    this.maxHouseSalesPrice = null;
    this.maxFlatUnitPrice = null;
  }

  filterPropertyToText(property: string) {
    let value = this.tempLoanCriteria[property];
    if (typeof value == "boolean" && value == true) {
      return;
    } else if (value != null && typeof value != "boolean") {
      return `: ${this.getPropertyValue(property)}`;
    } else if (value == null) {
      return;
    }
    return false;
  }

  checkFilterSelected(property: string) {
    return this.sharedSearchResultsService.checkFilterSelected(property, this.tempLoanCriteria);
  }

  getPropertyValue(property) {
    let propertyValue = this.tempLoanCriteria[property];
    switch (property) {
      case "f_PersonalGuaranteeMax":
        return this.selectListService
          .GetBridgingPersonalGuaranteeLevels()
          .find((item) => item.key === this.getPersonalGuaranteeLevelOptions())?.displayName;
      case "f_MaxHouseSalesPrice":
        return this.selectListService.GetMaxHouseSalePrices().find((item) => item.key === this.getMaxHouseSalesPrice())
          ?.displayName;
      case "f_MaxFlatUnitPrice":
        return this.selectListService.GetMaxFlatUnitPrices().find((item) => item.key === this.getMaxFlatUnitPrice())
          ?.displayName;
      case "f_MaxSqFtSalePrice":
        return this.selectListService.GetMaxSqFtSalePrices().find((item) => item.key === this.getMaxSqFtSalePrice())
          ?.displayName;
      case "f_MaxSqFtSalePriceFlats":
        return this.selectListService
          .GetMaxSqFtSalePrices()
          .find((item) => item.key === this.getMaxSqFtSalePriceFlats())?.displayName;
      case "f_NumberOfPreviousDevelopments":
        return this.selectListService
          .GetNumberOfPreviousDevelopmentsForBridging()
          .find((item) => item.key === this.getPreviousDevelopments())?.displayName;
      case "f_MaxNumberOfUnits":
        return propertyValue;
      case "f_ValuationMethod":
        return this.selectListService
          .GetValuationMethodOptions()
          .find((item) => item.key === this.tempLoanCriteria.f_ValuationMethod)?.displayName;
      case "f_MaxCommercialFloorspace":
        return this.selectListService
          .GetMaxCommercialFloorspaceOptions()
          .find((item) => item.key === this.tempLoanCriteria.f_MaxCommercialFloorspace)?.displayName;
      default:
        return propertyValue;
    }
  }

  countFiltersSelected() {
    let count = 0;
    count = this.sharedSearchResultsService.countFiltersSelected(this.tempLoanCriteria, this.filterProperties);
    return count;
  }

  getDisplayTextForProperty(property) {
    return this.sharedSearchResultsService.getDisplayTextForProperty(property);
  }

  splitCamelCase(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");
  }

  updateCriteriaAndGetResults(criteriaChanged: boolean, updateLoanLabels: boolean = false) {
    this.bridgingDealClient
      .updateSearchAndGetResults({
        bridgingDeal: this.loanCriteria,
        criteriaChanged: criteriaChanged,
        limit: 0,
        debug1: this.debug1,
        debug2: false,
        isPostcodeChange: this.isPostcodeChange,
        isShortlistingMore: this.isShortlistingMore,
      })
      .then((results: UpdateBridgingSearchGetResultResponse) => {
        if (this.isPostcodeChange) {
          if (results.criteriaLocation != null) {
            this.loanCriteria.locations = results.criteriaLocation;
            this.summarySearchResults = results.results;
          } else {
            this.postcodeErrorMsg = results.postCodeErrorMessage;
            this.showPostcodeErrorMessage = true;
          }
        } else {
          this.summarySearchResults = results.results;
          this.sortSummaryResults();
        }
      })
      .catch((error) => {})
      .finally(() => {
        this.tempLoanCriteria = { ...this.loanCriteria };
        this.clearSelected();
        this.isPostcodeChange = false;

        if (updateLoanLabels) {
          this.updateLoanLabels();
        }

        this.loadingData = false;
      });
  }

  /**Update the loan label in the comparison results based on the loan label returned in the results
   * Primary purpose is to update the loan label when the show lender names button is toggled
   * */
  updateLoanLabels() {
    for (var i = 0; i < this.comparisonList.length; i++) {
      let resultIndex = this.summarySearchResults.findIndex(
        (item) => item.productID == this.comparisonList[i].productID,
      );

      if (resultIndex > -1) {
        this.comparisonList[i].loanLabel = this.summarySearchResults[resultIndex].loanLabel;
      }
    }

    //This is used in shortlisting pdf
    this.prepareDataForShortlistPdf();
  }

  changeSearch() {
    (this.$rootScope as any).loanCriteria = this.loanCriteria;
    this.warningOff = true;
    sessionStorage.setItem("skip", "true");
    if (!this.isLoggedInUser && (this.dealUniqueRef || this.dealClientUniqueRef)) {
      if (this.dealClientUniqueRef) sessionStorage.setItem("previousRoute", "referredsearchdeal");
      var url = `/e/bridgingcriteria/${this.loanCriteria.uniqueRef}`;
      if (this.loanCriteria.organisationLinkId > 0) {
        url = `${url}/${this.loanCriteria.organisationLinkId}`;
      }
      this.go(url);
    } else if (this.searchid) {
      this.go("/bridgingcriteria/" + this.searchid);
    } else {
      this.go("/bridgingcriteria");
    }
  }

  newloan() {
    (this.$rootScope as any).loanCriteria = null;
    this.$location.path("/bridgingcriteria/0");
  }

  getSearchResultCount() {
    return this.sharedSearchResultsService.getSearchResultCount(this.summarySearchResults);
  }

  checkDeletedLender(lenderId: number, productId: number): boolean {
    if (this.isShortlistingMore && this.deletedDealLenders) {
      const deletedLender = this.deletedDealLenders.find((deletedLender) => deletedLender.lenderId === lenderId);

      if (deletedLender) {
        return deletedLender.productId === productId;
      }
    }
    return false;
  }

  getSearchLenderCount() {
    this.lenderClient
      .getTotalLenders(ProductFamilyEnum.Bridging, this.loanCriteria.brokerOrganisationId)
      .then((result: number) => {
        this.totalLender = result;
      });
  }

  // updateGuidanceState() {
  //   this.tourEnabled = this.sharedSearchResultsService.updateGuidanceState(
  //     this.guidanceCheckbox,
  //   );
  // }

  // getGuidanceSwitchState() {
  //   return this.sharedSearchResultsService.getGuidanceSwitchState();
  // }

  // recordGuidanceCookie() {
  //   this.sharedSearchResultsService.recordGuidanceCookie(this.guidanceCheckbox);
  //   this.$rootScope.$broadcast("guidanceStateChanged");
  // }

  // tourNext(): void {
  //   this.tourState.tourStep++;
  //   this.$cookies.put("tourStep", this.tourState.tourStep);
  // }

  // tourBack(): void {
  //   this.tourState.tourStep--;
  //   this.$cookies.put("tourStep", this.tourState.tourStep);
  // }

  // tourSkip(): void {
  //   this.tourEnabled = false;
  //   this.$cookies.put("tourEnabled", "false");
  //   this.$cookies.remove("tourStep");
  // }

  // startTour(): void {
  //   this.tourState.tourStep = 1;
  //   this.tourState.tourTotalSteps = 0;
  //   this.$cookies.put("tourStep", this.tourState.tourStep);
  //   this.tourEnabled = true;
  //   this.$cookies.put("tourEnabled", "true");
  // }

  /**
   * Saves the new search name on the edit.
   * @param none
   */
  doRenameSearch() {
    if (this.loanCriteria.name != null && this.loanCriteria.name.length <= 0) {
      this.loanCriteria.name = this.tempLoanCriteria.name;
    }

    if (!this.isLoggedInUser) {
      this.openRegisterModal();
      return;
    }

    const request: SaveBridgingSearchRequest = {
      deal: this.loanCriteria,
      shareDealDto: this.shareDealDto,
      orgCode: this.orgCode,
      enterpriseClientDto: null,
    } as SaveBridgingSearchRequest;

    if (this.searchid) {
      this.bridgingDealClient.saveBridgingSearchReturnsId(request).then((response) => {
        this.toggleEditSearchName = false;
      });
    } else if (this.dealUniqueRef) {
      if (this.isLoggedInUser) {
        this.bridgingDealClient.saveBridgingSearchReturnsUniqueRef(request).then((response) => {
          this.toggleEditSearchName = false;
        });
      } else {
        this.dealClient.renameDeal(this.dealUniqueRef, this.loanCriteria.name).then((response) => {
          this.toggleEditSearchName = false;
        });
      }
    } else {
      this.toggleEditSearchName = false;
    }
  }

  /**
   * Gets the search results and criteria for selected search
   * @param none
   */
  getSearchCriteriaAndResults() {
    if (window.self == window.top) {
      this.snapshotNewSearch = sessionStorage.getItem("newSearch") == "true";
      sessionStorage.setItem("newSearch", "false");
    }

    if (this.searchid) {
      this.loadingData = true;
      this.bridgingSearchClient
        .getSearchCriteriaAndResults({
          dealId: this.searchid,
          criteriaChanged: this.snapshotNewSearch,
          limit: 0,
          debug1: false,
          debug2: false,
          dealClientUniqueRef: null,
          dealUniqueRef: null,
          returnSearchCriteriaDTO: true,
        })
        .then((results) => {
          if (!results || !results.criteria) {
            this.noAccessToDealMsg = "Unable to find deal.";
            this.hasAccessToDeal = false;
          }

          this.postResultsProcessing(results);
        })
        .then(() => {
          if (this.summarySearchResults != null) {
            const productIds = this.summarySearchResults.map((product) => product.productID);
            this.getProductLastVerifiedDates(productIds);
          }
        })
        .then(() => {
          this.getSearchLenderCount();
          if (this.isLoggedInUser) this.getSelectedProducts();
          this.updateLoanLabels();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          if (this.loanCriteria) {
            this.isMaximumLoanRequired = this.loanCriteria.maxLoanRequired;
            this.currentUseOptions = this.selectListService.GetPropertyTypes(this.loanCriteria.productType);
            this.isSearch = this.loanCriteria && this.loanCriteria.status == CaseStatusEnum.Search;
            this.tempLoanCriteria = { ...this.loanCriteria };
            this.$caseService.updateTubeMap(this.loanCriteria.status);
            this.loadingData = false;
            this.hasResultsProcessed = true;
          }
        });
    } else if (this.dealUniqueRef) {
      this.loadingData = true;
      this.bridgingSearchClient
        .getSearchCriteriaAndResults({
          dealUniqueRef: this.dealUniqueRef,
          criteriaChanged: this.snapshotNewSearch,
          dealId: null,
          dealClientUniqueRef: null,
          returnSearchCriteriaDTO: true,
          limit: 0,
          debug1: false,
          debug2: false,
        })
        .then((results) => {
          this.postResultsProcessing(results);
        })
        .then(() => {
          if (this.summarySearchResults != null) {
            const productIds = this.summarySearchResults.map((product) => product.productID);
            this.getProductLastVerifiedDates(productIds);
          }
        })
        .then(() => {
          this.getSearchLenderCount();
          if (this.loanCriteria) this.getSelectedProducts();
          this.updateLoanLabels();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          if (this.loanCriteria) {
            this.isMaximumLoanRequired = this.loanCriteria.maxLoanRequired;
            this.currentUseOptions = this.selectListService.GetPropertyTypes(this.loanCriteria.productType);
            this.isSearch = this.loanCriteria && this.loanCriteria.status == CaseStatusEnum.Search;
            this.tempLoanCriteria = { ...this.loanCriteria };
            //this.$caseService.updateTubeMap(this.loanCriteria.status);
            this.loadingData = false;
            this.hasResultsProcessed = true;
          }
        });
    } else if (this.dealClientUniqueRef) {
      this.loadingData = true;
      this.bridgingSearchClient
        .getSearchCriteriaAndResults({
          dealClientUniqueRef: this.dealClientUniqueRef,
          criteriaChanged: this.snapshotNewSearch,
          dealId: null,
          dealUniqueRef: null,
          returnSearchCriteriaDTO: true,
          limit: 0,
          debug1: false,
          debug2: false,
        })
        .then((results) => {
          this.postResultsProcessing(results);
        })
        .then(() => {
          if (this.loanCriteria) this.getSelectedProducts();
          this.getSearchLenderCount();
          if (sessionStorage.getItem("LoanCriteria") && (this.$rootScope as any).previousRoute.startsWith("/compare")) {
            this.comparisonList = JSON.parse(sessionStorage.getItem("ComparisonList"));
            //Removing lsd data saved for compare view.
            sessionStorage.removeItem("LoanCriteria");
            sessionStorage.removeItem("ComparisonList");
          }
        })
        .finally(() => {
          if (this.loanCriteria) {
            this.isMaximumLoanRequired = this.loanCriteria.maxLoanRequired;
            this.currentUseOptions = this.selectListService.GetPropertyTypes(this.loanCriteria.productType);
            this.isSearch = this.loanCriteria && this.loanCriteria.status == CaseStatusEnum.Search;
            //this.$caseService.updateTubeMap(this.loanCriteria.status);
            this.tempLoanCriteria = { ...this.loanCriteria };
            this.loadingData = false;
            this.hasResultsProcessed = true;
          }
        });
    }
  }

  postResultsProcessing(results: BridgingSearchResultsResponse) {
    if (results.hideDeal || results.hasNoAccessToDeal) {
      if (results.hasNoAccessToDeal) {
        if (this.isClient) {
          this.noAccessToDealMsg = "Please contact your broker in order to access this case.";
        } else {
          this.noAccessToDealMsg = "Error retrieving deal.";
        }
      }

      if (results.hideDeal) {
        this.noAccessToDealMsg =
          "You cannot access Bridging search results. Please contact your admin for more details.";
      }

      this.hasAccessToDeal = false;
    } else {
      this.summarySearchResults = this.initialSummarySearchResults = results.results;
      this.loanCriteria = results.criteria;

      if (this.isLoggedInUser) {
        this.validateAccessAndRedirect();
      }

      this.sortSummaryResults();

      if (this.isLoggedInUser) {
        if (this.dealClientUniqueRef) {
          if (this.isClient) {
            this.eventLogClient.logPageLoad(
              "AFTER-ENTERPRISE-LEAD-REGISTRATION-USING-EMAIL-LINK",
              this.orgCode,
              this.selectedUserName,
              "Client",
              this.loanCriteria?.organisationLinkId,
              this.loanCriteria.productType,
              "",
              this.loanCriteria?.id,
            );
          }
        } else {
          if (this.loanCriteria.lenderReferralLenderId) this.isLenderReferredSearch = true;

          // Showing confirm client phone number modal once client register through result page
          if (this.isClient && sessionStorage.getItem("showConfirmClientPhoneNo") == "true") {
            this.showClientPhoneNumberConfirmationModal = true;
            this.clientUpdatedContact = this.loanCriteria?.dealClients[0].client.phoneNumber;
          }

          this.dealProductTypeDisplayText = ProductHelper.getProductTypeDisplayText(this.loanCriteria.productType);

          // Expanding a 'new search' panel for first time search execution
          if (window.self == window.top && sessionStorage.getItem("newSearch")) {
            this.sliderShown =
              (this.$rootScope as any).previousRoute.startsWith("/compare") ||
              this.showClientPhoneNumberConfirmationModal
                ? false
                : true;
            sessionStorage.removeItem("newSearch");
          }
        }
      } else {
        if (this.$location.path().startsWith("/e/bridgingresults")) {
          this.populateEnterpriseClientValue("LENDERRESULTS");
        }

        if (this.dealClientUniqueRef) {
          if (this.$routeParams.showOnlyRegister == "false") this.isClient = true;
          this.populateEnterpriseClientValue("LENDERRESULTS-USING-EMAIL-LINK");
        }
      }

      var owner =
        this.loanCriteria.dealClients != null && this.loanCriteria.dealClients?.length > 0
          ? this.loanCriteria.dealClients.find((dc) => dc.isPrimary)
          : null;

      if (owner) {
        this.isAssigned = true;
      }
    }
  }

  go(path): void {
    this.$location.path(path);
  }

  toggleLenderComparisonSelection(item: BridgingLenderResultSummaryDTO, index: number) {
    let comparisonMatches: BridgingLenderResultSummaryDTO[] = this.comparisonList.filter((result, index) => {
      return result.productID === item.productID;
    });

    if (!comparisonMatches || comparisonMatches.length === 0) {
      this.comparisonList.push(item);
      this.eventLogClient.logEvent(
        `SHORTLISTING-RESULT`,
        EventLogEnum.Shortlisting,
        this.loanCriteria.productType,
        this.loanCriteria.id,
        "",
        item.productID.toString(),
        0,
      );
    } else {
      if (
        this.isShortlistingMore &&
        item.isDealLender &&
        this.loanCriteria.status != CaseStatusEnum.Search &&
        this.loanCriteria.status != CaseStatusEnum.NewCase
      )
        return;
      comparisonMatches.forEach((value, index) => {
        this.comparisonList.splice(this.comparisonList.indexOf(value), 1);
      });
      this.eventLogClient.logEvent(
        `DESELECTING-SHORTLISTED-RESULT`,
        EventLogEnum.Shortlisting,
        this.loanCriteria.productType,
        this.loanCriteria.id,
        "",
        item.productID.toString(),
        0,
      );
    }
    //This is user for shortlisting pdf
    this.prepareDataForShortlistPdf();
  }

  comparisonContains(item: BridgingLenderResultSummaryDTO): boolean {
    return !!this.comparisonList.find((result, index) => {
      return result.productID === item.productID;
    });
  }

  checkLender(item: BridgingLenderResultSummaryDTO): boolean {
    if (this.userLenderId == item.lenderID) return true;
    return false;
  }

  selectionOrderNumber(item: BridgingLenderResultSummaryDTO) {
    var activeProductList = this.comparisonList.filter(
      (cl) =>
        cl.dealLenderStatus != CaseLenderStateEnum.Rejected && cl.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
    );

    var hiddenProduct = this.HiddenDealLenderList.filter(
      (hl) => hl.status != CaseLenderStateEnum.Rejected && hl.status != CaseLenderStateEnum.Withdrawn,
    );
    var hiddenProductLength = this.isShortlistingMore ? hiddenProduct.length : 0;

    var order = activeProductList.map((item) => item.productID).indexOf(item.productID) + hiddenProductLength + 1;
    if (order === 0) {
      return " ";
    }

    return order;
  }

  /**
   * Processes the clicking of the "View Eligibility" anchor/button and index to show on the row number
   * @param item BridgingLenderResultSummaryDTO
   */
  viewEligibility(item: BridgingLenderResultSummaryDTO) {
    event.preventDefault(); // prevents default behaviour of href
    this.showProductNote = true;
    this.offer = item;
    this.loanLabel = item.loanLabel;
    this.productNote = item.additionalProductInfo;
  }

  /**
   *Marks a selected search as a deleted
   * @param
   */
  deleteSearch() {
    if (this.$routeParams.SearchId) {
      this.dealClient
        .markAsDeleted(this.$routeParams.SearchId)
        .then((response) => {
          this.displayMsg = "Search is successfully deleted";
          this.showMsg = true;
          this.ShowdeleteSearch = true;
        })
        .catch((error) => {
          this.displayMsg = "Sorry, something went wrong. Please try again.";
          this.showMsg = true;
        });
    }
  }

  closeDeleteModal() {
    this.showMsg = false;
    this.displayMsg = null;
    this.ShowdeleteSearch = false;
    this.warningOff = true;
    this.$auth.clearSelectedNavMenuAndFilterStorageData();
    this.go("/userdashboard");
  }

  viewSingleLoan(item: BridgingLenderResultSummaryDTO) {
    event.preventDefault(); // prevents default behaviour of href
    this.warningOff = true;
    //Storing the actual comparisonList to local storage so that to recover it later when we comeback to result screen from compare screen.
    sessionStorage.setItem("actualcomparisonList", JSON.stringify(this.comparisonList));
    this.comparisonList = [];

    this.comparisonList.push(item);
    this.goCompare();
    (this.$rootScope as any).loanCriteria = this.loanCriteria;
  }

  goCompare() {
    this.warningOff = true;

    this.sharedSearchResultsService.clearStorageDataForCompareView();
    let comparisonList = this.comparisonList.filter(
      (cl) =>
        cl.dealLenderStatus != CaseLenderStateEnum.Rejected && cl.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
    );

    sessionStorage.setItem("ComparisonList", JSON.stringify(comparisonList));
    sessionStorage.setItem("LoanCriteria", JSON.stringify(this.loanCriteria));

    // temporarily put all results into saved results so the comparison controller can use them.
    let allResults: BridgingLenderResultSummaryDTO[] = [];
    this.summarySearchResults.forEach((result) => {
      allResults.push(result);
    });

    sessionStorage.setItem("TempSavedResults", JSON.stringify(allResults));

    if (this.dealClientUniqueRef) {
      if (!this.isLoggedInUser) {
        this.dealUniqueRef = this.loanCriteria.uniqueRef;
        //This property is used in compare view controller to find previous route
        sessionStorage.setItem("DealClientUniqueRef", this.dealClientUniqueRef);
      } else {
        this.searchid = this.loanCriteria.id;
      }
    }

    if (this.searchid) {
      this.$location.path("compare/" + this.searchid + "/" + 0 + "/" + true);
    } else {
      this.$location.path("compare/" + this.dealUniqueRef + "/" + 0 + "/" + true);
    }
  }

  /**
   * Opens the modal to enter new name or calls 'register' method to svae and promote search to case.
   */

  applyForLoan() {
    this.isProceedClicked = true;
    this.register(true, this.productResultList);
    //if (this.searchid && this.loanCriteria.searchName.startsWith('My Loan Search')) {
    //    this.showSaveResults = 2;
    //} else if (this.searchid) {
    //    this.register(true, this.productResultList)
    //}
  }

  getDealLenders(selectedLenders: BridgingLenderResultSummaryDTO[]) {
    var lendersList: DealLender[] = [];

    if (this.dealClientUniqueRef || this.dealUniqueRef) {
      this.searchid = this.loanCriteria.id;
    }

    selectedLenders.forEach(({ productID, lenderID, grossLoan }) => {
      var dealLender: DealLender;

      if (this.dealLenders) {
        dealLender = this.dealLenders.find(
          (dl) => dl.dealId === this.searchid && dl.productId === productID && dl.lenderId === lenderID,
        );
      }

      if (!dealLender) {
        dealLender = {
          dealId: this.searchid,
          productId: productID,
          lenderId: lenderID,
          status: CaseLenderStateEnum.Shortlisted,
          originalTotalGrossLoan: grossLoan,
          deal: null,
          product: null,
          lender: null,
        } as DealLender;
      }

      lendersList.push(dealLender);
    });

    var unselecteLenderList: DealLender[] = [];

    if (this.dealLenders) {
      unselecteLenderList = this.dealLenders.filter(
        (dl) =>
          !lendersList.some((ll) => ll.productId === dl.productId && ll.lenderId === dl.lenderId) &&
          (dl.status == CaseLenderStateEnum.Rejected || dl.status == CaseLenderStateEnum.Withdrawn),
      );
    }

    if (unselecteLenderList.length > 0) {
      unselecteLenderList.forEach((l) => {
        l.isDeleted = true;
        lendersList.push(l);
      });
    }

    return lendersList;
  }

  getSelectedProducts() {
    if (this.summarySearchResults && this.summarySearchResults.length > 0) {
      this.dealLenderClient
        .fetchDealLendersByDealId(this.dealClientUniqueRef || this.dealUniqueRef ? this.loanCriteria.id : this.searchid)
        .then((results) => {
          this.dealLenders = results;
        })
        .then(() => {
          this.comparisonList = this.summarySearchResults.filter((result) => {
            const isDealLender = this.dealLenders.find((dealLender) => dealLender.productId === result.productID);
            if (isDealLender) {
              result.dealLenderStatus = isDealLender.status;
            }
            return (result.isDealLender = Boolean(isDealLender));
          });

          // Previously shortlisted/submitted lenders which are not visible on current results because of criteria change
          this.HiddenDealLenderList = this.dealLenders.filter(
            (l) => !this.summarySearchResults.some((s) => l.productId === s.productID),
          );

          if (this.comparisonList.length > 0) {
            var inActiveDealLenderList = this.comparisonList.filter(
              (ia) =>
                ia.dealLenderStatus == CaseLenderStateEnum.Rejected ||
                ia.dealLenderStatus == CaseLenderStateEnum.Withdrawn,
            );
            this.inActiveDealLender = inActiveDealLenderList.length;
          }

          if (sessionStorage.getItem("LoanCriteria") && (this.$rootScope as any).previousRoute.startsWith("/compare")) {
            if (sessionStorage.getItem("actualcomparisonList")) {
              var selectedProducts = sessionStorage.getItem("actualcomparisonList");
              this.comparisonList = JSON.parse(selectedProducts);
              sessionStorage.removeItem("actualcomparisonList");
            } else {
              this.comparisonList = JSON.parse(sessionStorage.getItem("ComparisonList"));
            }
            if (this.inActiveDealLender > 0) {
              this.comparisonList = this.comparisonList.concat(inActiveDealLenderList);
            }

            //Removing lsd data saved for compare view.
            sessionStorage.removeItem("LoanCriteria");
            sessionStorage.removeItem("ComparisonList");
          }
        });
    }
  }

  /**
   * Saves the search or saves the search and create a case.
   * @param createCase (boolean set to true when promoting search to case)
   */
  register(createCase: boolean = false, productResultList: number) {
    this.loadingData = true;

    if (this.isShortlistingMore) {
      if (this.validateAllLendersUnique(this.comparisonList) == true) {
        this.dealLenderClient
          .shortlistMoreLenders(this.loanCriteria.id, this.hasSearchChanged, this.getDealLenders(this.comparisonList))
          .then((response) => {})
          .then(() => {
            this.getSelectedProducts();
          })
          .finally(() => {
            this.loadingData = false;
          });
      } else {
        this.loadingData = false;
      }
    } else {
      if (this.shareDealDto && this.shareDealDto.dealName && this.shareDealDto.dealName.length > 0) {
        this.loanCriteria.name = this.shareDealDto.dealName;
      }

      var request: SaveBridgingSearchRequest = {
        deal: this.loanCriteria,
        shareDealDto: null,
        orgCode: "",
        enterpriseClientDto: null,
      } as SaveBridgingSearchRequest;

      this.bridgingDealClient
        .saveBridgingSearchReturnsId(request)
        .then((response) => {
          this.loanCriteria.id = response as number;
          this.loadingData = false;

          // Creating the case is done on the casedashboard for deals
          if (createCase) {
            this.$location.path("/bridgingcasedashboard/" + this.loanCriteria.id + "/" + true);
          }

          var shortlistDealLenders = this.getDealLenders(this.comparisonList);

          const shortlistRequest: ShortlistRequest = {
            dealLenders: shortlistDealLenders,
            commercialShortlistedResults: null,
            bridgingShortlistedResults: this.comparisonList,
            devFinanceShortlistedResults: null,
          } as ShortlistRequest;

          this.dealLenderClient
            .dealLenderAddUpdateListReturnOnlyId(shortlistRequest)
            .then((response) => {
              let deallenders = this.dealLenders.filter((lender) => response.indexOf(lender.id) === -1);

              deallenders.forEach((lender) => this.dealLenderClient.markAsDeleted(lender.id));
            })
            .finally(() => {
              this.getSelectedProducts();
              this.isClicked = false;
              this.newSearch = false;
              this.isProceedClicked = false;
              this.showSaveResults = null;
              this.loadingData = false;
            });
        })
        .catch((response) => {
          //TODO BRIDGING - capture if an error has occurred and process it
          //this.isError = true;
          this.isProceedClicked = false;
        })
        .finally(() => {});
    }
  }

  /*onClickSaveAs() {
            this.showSaveResults = 3;
            this.tempSearchName = this.loanCriteria.name;
            this.loanCriteria.name = '';
        }

        saveAs() {

            this.isSaveorSaveAsClicked = true;
            this.register(false, this.productResultList);
        }*/

  onClickSaveAs() {
    this.isSaveAsClicked = true;
    if (this.isAdmin || this.isBroker) {
      if (!this.shareDealDto) {
        this.shareDealDto = {
          isApplicant: true,
          isPrimary: true,
        } as ShareDealDTO;
      }
      this.shareDealDto.dealName = "";
      this.showShareSearchModal();
    } else {
      this.showSaveResults = 3;
    }
  }

  openSendResultsToBorrowerModal() {
    var client = this.loanCriteria.dealClients[0]["client"]; // TODO BRIDGING FUTURE- always want to assume there's one for now until there's a redesign of sharing
    this.shareDealDto.dealId = this.loanCriteria.id;
    this.shareDealDto.dealName = this.loanCriteria.name;
    this.shareDealDto.isApplicant = true;
    this.shareDealDto.isPrimary = true;
    this.shareDealDto.clientDto = {
      firstName: client.firstName,
      lastName: client.lastName,
      email: client.email,
      phoneNumber: client.phoneNumber,
      clientUserId: client.clientUserId,
      postalAddress: client.postalAddress ?? {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      },
    } as Client;
    this.existingborrower = null;
    this.newSearch = true;
    this.sharedSearch = true;
  }

  /**
   * Sends email to client attached to the search
   */
  sendShareSearchEmailToClient() {
    this.dataLoading = true;
    this.shareDealDto.emailLinkToClient = true;
    this.dealClient
      .shareDeal(this.shareDealDto)
      .then(() => {
        this.displayMsg =
          "Search results have been sent to " +
          this.shareDealDto.clientDto.firstName +
          " " +
          this.shareDealDto.clientDto.lastName;
      })
      .catch((error) => {
        this.displayMsg = "Sorry, something went wrong. Please try again.";
      })
      .finally(() => {
        this.newSearch = false;
        this.showMsg = true;
        this.dataLoading = false;
        this.sharedSearch = false;
      });
  }

  /**
   * Opens a 'share a search with client' modal if search do not have client attached to.
   * @param none
   */
  /* saveAsWthOutIntroducee() {
            this.isSaveAsWthOutIntroducee = true;
            this.tempSearchName = this.loanCriteria?.Name;
            //this.loanCriteria.name = '';
            this.showShareSearchModal()
        }*/

  /**
   * Opens a 'share a search with client' modal if search do not have client attached to.
   * @param none
   */
  saveResultsForShareSearchToClient() {
    if (!this.isSaveAsClicked) {
      this.register(false, this.productResultList);
    } else {
      this.saveSaveAsSearch();
    }
    this.newSearch = false;
  }

  showShareSearchModal() {
    this.newSearch = true;

    this.shareDealDto = {
      dealId: this.searchid,
      dealName: this.isSaveAsClicked ? "" : this.loanCriteria?.name,
      showLenderNamesAndLogos: this.loanCriteria?.showLenderInfoBrokerOverride,
      emailLinkToClient: false,
      accessLevel: CaseAccessLevelEnum.FullAccess,
      isApplicant: true,
      isPrimary: true,
    } as ShareDealDTO;

    this.shareDealDto.clientDto = {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
    } as Client;
  }

  /**
   * updates a seach with introducee details and saves it and sends emil to client if 'notifyBorrower' is set to true.
   * @param notifyBorrower
   */

  sendResultsToClient(notifyBorrower) {
    if (this.shareDealDto != null && this.shareDealDto.clientDto != null) {
      this.shareDealDto.clientDto.postalAddress = this.shareDealDto.clientDto.postalAddress ?? {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      };
    }
    if (this.isSaveAsClicked) {
      this.saveSaveAsSearch(true);
    } else {
      this.loadingData = true;
      this.dealClient
        .shareDeal(this.shareDealDto)
        .then(() => {
          this.displayMsg =
            "Search results have been sent to " +
            this.shareDealDto.clientDto.firstName +
            " " +
            this.shareDealDto.clientDto.lastName;
          //this.loanCriteria.dealClients[0] = this.shareDealDto.ClientDto;
          this.loanCriteria.name = this.shareDealDto.dealName;
          this.newSearch = false;
          this.showMsg = true;
          this.reloadSearch = true;
          this.loadingData = false;
          this.isAssigned = true;
        })
        .finally(() => {
          delete this.shareDealDto;
          this.loadingData = false;
        });
    }
  }

  cancelSavePopup() {
    this.showSaveResults = null;
    this.loanCriteria.name = this.searchNameCache;
  }

  showBookMeetingButton() {
    return !this.isLoggedInUser && this.isClient && this.brokerDetail == "" && this.brokerageOrg != null;
  }

  bookMeeting() {
    this.staticDataClient.getHubspotDeveloperBookMeetingWithSearch().then((hubSpotUrl: string) => {
      window.open(hubSpotUrl);
    });
  }

  sendMessageToBroker(message) {
    this.loadingData = true;
    this.borrowerMessage = null;
    this.organisationClient
      .sendBorrowerMessageToSearchBroker(
        this.loanCriteria.id,
        message,
        this.loanCriteria.dealClients[0].client.firstName,
        this.loanCriteria.dealClients[0].client.lastName,
        this.loanCriteria.dealClients[0].client.email,
        this.loanCriteria.productType,
        "BRIDGINGRESULTSSCREEN",
        "",
      )
      .then((results) => {
        if (results) {
          this.displayMsg = `Message has been sent successfully.`;
          this.showMessageToborrower = true;
        } else {
          this.displayMsg = `There is problem sending a message, Please try later.`;
          this.showMessageToborrower = true;
        }
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  closeContactBrokerModal() {
    this.showContactBrokerModal = false;
    this.showMessageToborrower = false;
    this.displayMsg = null;
  }

  getTotalShortlistedLenders() {
    var activeDealLenders = this.comparisonList.filter(
      (al) =>
        al.dealLenderStatus != CaseLenderStateEnum.Rejected && al.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
    );
    var hiddenProduct = this.HiddenDealLenderList.filter(
      (hl) => hl.status != CaseLenderStateEnum.Rejected && hl.status != CaseLenderStateEnum.Withdrawn,
    );
    var hiddenProductLength = this.isShortlistingMore ? hiddenProduct.length : 0;

    return activeDealLenders.length + hiddenProductLength;
  }

  isLendersFiltered(): boolean {
    //If the search is empty return true
    if (!this.summarySearchResults && this.caseLenders) return true;

    if (!this.caseLenders) return false;

    //For all products that have been submitted for DIP and active, check if in the search
    return !this.caseLenders.every((lender) => {
      if (
        lender.caseLenderState !== CaseLenderStateEnum.Withdrawn &&
        lender.caseLenderState !== CaseLenderStateEnum.Rejected
      ) {
        const match = this.summarySearchResults.some(
          (summarySearchResult) => lender.productId === summarySearchResult.productID,
        );
        if (!match) {
          if (this.filterLenderNames.indexOf(lender.lenderName) === -1) {
            this.filterLenderNames.push(lender.lenderName);
          }
        }
        return match;
      }
      return true;
    });
  }

  getLenderNames(): string {
    if (this.filterLenderNames.length === 1) {
      return "lender " + this.filterLenderNames[0];
    } else {
      return "lenders " + this.filterLenderNames.join(", ");
    }
  }

  viewClientsDashboardForNewSearch(userName: string) {
    this.loadingData = true;
    this.shareDealDto.isApplicant = true;
    this.shareDealDto.isPrimary = true;
    //Look up client's account details
    this.userClient.searchByEmail(userName).then((users) => {
      this.shareDealDto.clientDto.firstName = users[0].firstName;
      this.shareDealDto.clientDto.email = users[0].email;
      this.shareDealDto.clientDto.lastName = users[0].lastName;
      this.shareDealDto.clientDto.phoneNumber = users[0].phoneNumber;
      this.shareDealDto.clientDto.clientUserId = users[0].id;
      this.showClientDetails = true;
      this.loadingData = false;
    });
  }

  returnToCase() {
    const shortlistDealLenders = this.getDealLenders(this.comparisonList);
    const shortlistRequest: ShortlistRequest = {
      dealLenders: shortlistDealLenders,
      commercialShortlistedResults: null,
      bridgingShortlistedResults: this.comparisonList,
      devFinanceShortlistedResults: null,
    } as ShortlistRequest;

    if (this.isShortlistingMore) {
      // copy newly selected products/lenders to caselender
      this.dealLenderClient
        .shortlistMoreLenders(this.loanCriteria.id, this.hasSearchChanged, shortlistRequest)
        .then((response) => {
          if (response) {
            //sending 'Promote' as true if search has changed & 'NewShortlist' as true if isShortlistingMore
            this.$location.path(
              "/bridgingcasedashboard/" + this.loanCriteria.id + "/" + null + "/" + true + "/" + this.hasSearchChanged,
            );
          }
        });
    } else {
      this.dealLenderClient.updateShortlistedLenders(shortlistRequest).then((response) => {
        this.$location.path("/bridgingcasedashboard/" + this.loanCriteria.id);
      });
    }
  }

  updateSearchViaSlider(isAdminDebugValueChanged: boolean = false): void {
    if (this.searchPanelForm.$valid && !this.showPostcodeErrorMessage) {
      if (
        this.loanCriteria.productType != ProductTypeEnum.BridgingDeveloperExit &&
        !(
          this.loanCriteria.ownOrPurchase == OwnOrPurchaseEnum.Own &&
          this.loanCriteria.productType == ProductTypeEnum.BridgingPurchaseOrRefinance
        ) &&
        !(this.loanCriteria.ownOrPurchase == 1 && this.loanCriteria.productType == ProductTypeEnum.BridgingRefurb)
      ) {
        if (this.loanCriteria.purchasePrice <= 0) return;
      }

      if (
        this.loanCriteria.productType == ProductTypeEnum.BridgingDeveloperExit ||
        (this.loanCriteria.ownOrPurchase == OwnOrPurchaseEnum.Own &&
          this.loanCriteria.productType == ProductTypeEnum.BridgingPurchaseOrRefinance) ||
        (this.loanCriteria.ownOrPurchase == 1 && this.loanCriteria.productType == ProductTypeEnum.BridgingRefurb)
      ) {
        if (this.loanCriteria.currentvalue <= 0) return;
      }

      if (this.loanCriteria.productType == ProductTypeEnum.BridgingRefurb) {
        if (this.loanCriteria.gdv <= 0) return;
      }
      this.loadingData = true;

      this.hasSearchChanged = true;

      this.clearSelected();

      this.updateCriteriaAndGetResults(isAdminDebugValueChanged && this.isAdmin ? false : true);
    }
  }

  //Clears the client data on share search modal
  clearInputFields() {
    this.shareDealDto.clientDto.firstName = null;
    this.shareDealDto.clientDto.lastName = null;
    this.shareDealDto.clientDto.email = null;
    this.shareDealDto.clientDto.phoneNumber = null;
    this.shareDealDto.isApplicant = true;
    this.shareDealDto.isPrimary = true;
    this.showClientDetails = false;
    this.selecteduserName = null;
  }

  /** Redirects to the user dashboard */
  goToUserDashboard() {
    this.$auth.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  getTubeMapValue() {
    return this.$caseService.getTubeMap();
  }

  updateLoanRequiredValue() {
    this.loanCriteria.maxLoanRequired = this.isMaximumLoanRequired;

    if (this.isMaximumLoanRequired) {
      if (this.loanCriteria.netLoanRequired) {
        this.tempLoanRequired = this.loanCriteria.netLoanRequired;
      }
      this.loanCriteria.netLoanRequired = 0;
      this.updateSearchViaSlider();
    } else {
      this.loanCriteria.netLoanRequired = this.tempLoanRequired;
      this.updateSearchViaSlider();
    }
  }

  calculateMonthsSinceOrigPurchase() {
    let date1 = new Date(this.loanCriteria.originalPurchaseDate);
    let date2 = new Date();
    let months;
    months = (date2.getFullYear() - date1.getFullYear()) * 12;
    months -= date1.getMonth();
    months += date2.getMonth();
    return months;
  }

  datasetupOnEndPropertyTypeChange() {
    this.updateSearchViaSlider();
  }

  logPdfDownload(eventName) {
    this.eventLogClient.logEvent(eventName, EventLogEnum.Export, this.loanCriteria.productType, this.loanCriteria.id);
  }

  gotoSignInPage() {
    this.$location.path("/login");
  }

  goToLink(url) {
    var baseUrl = window.location.href.split("#!")[0] + "#!";
    var newUrl = baseUrl + url;
    window.open(newUrl, "_blank");
  }

  toggleShowLenderNamesBrokerOverride() {
    // this.loanCriteria.showLenderInfoBrokerOverride = !this.loanCriteria.showLenderInfoBrokerOverride;
    if (this.searchPanelForm.$valid && !this.showPostcodeErrorMessage) {
      this.updateCriteriaAndGetResults(false, true);
    }
  }

  getAppName() {
    let lsd = null;
    if (window.self == window.top) lsd = sessionStorage.getItem("applicationName");
    if (lsd != null) {
      this.appName = lsd;
    } else {
      this.appName = "Brickflow";
    }
  }

  onSelectingExportShortlist(eventName) {
    let comparisonList = this.comparisonList.filter(
      (cl) =>
        cl.dealLenderStatus != CaseLenderStateEnum.Rejected && cl.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
    );
    this.loanCriteria.comparisonList = comparisonList;
    this.eventLogClient.logEvent(eventName, EventLogEnum.Export, this.loanCriteria.productType, this.loanCriteria.id);
  }

  showContactBrokerAndExportButton() {
    if (
      this.brokerageOrg != null &&
      this.loanCriteria != null &&
      this.loanCriteria.dealClients != null &&
      this.loanCriteria.dealClients.length > 0 &&
      this.loanCriteria.dealClients[0]?.client != null &&
      this.loanCriteria.dealClients[0].client.email.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  //This is used in shortlisting pdf
  prepareDataForShortlistPdf() {
    this.loanCriteria.comparisonList = this.comparisonList.filter(
      (cl) =>
        cl.dealLenderStatus != CaseLenderStateEnum.Rejected && cl.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
    );
  }

  getRegionByPostcode() {
    if (this.loanCriteria.postcodeSearchString && this.loanCriteria.postcodeSearchString.replace(" ", "").length >= 2) {
      if (DealHelper.isValidPostcodeString(this.loanCriteria.postcodeSearchString)) {
        this.showPostcodeErrorMessage = false;
        this.isPostcodeChange = true;
        this.updateSearchViaSlider();
      } else {
        this.postcodeErrorMsg = "At least one letter and one number must be entered e.g. SW1.";
        this.showPostcodeErrorMessage = true;
      }
    }
  }

  sortByField(field) {
    this.loanCriteria.sortBy = field;
    this.updateCriteriaAndGetResults(false, false);
    this.showSortBy = !this.showSortBy;
  }

  sortSummaryResults() {
    switch (this.loanCriteria && this.loanCriteria.sortBy) {
      case SortByEnum.TrueMonthlyCost:
        this.summarySearchResults.sort((a, b) => a.trueMonthlyCost - b.trueMonthlyCost);
        break;
      case SortByEnum.NetLoanSize:
        this.summarySearchResults.sort((a, b) => b.netLoan - a.netLoan || a.trueMonthlyCost - b.trueMonthlyCost);
        break;
      case SortByEnum.LenderCosts:
        this.summarySearchResults.sort(
          (a, b) => a.lenderCosts - b.lenderCosts || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;
      case SortByEnum.LenderName:
        this.summarySearchResults.sort(
          (a, b) => a.lenderName.localeCompare(b.lenderName) || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;
      case SortByEnum.InterestRate:
        this.summarySearchResults.sort(
          (a, b) => a.annualInterest - b.annualInterest || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;
      case SortByEnum.ArrangementFee:
        this.summarySearchResults.sort(
          (a, b) => a.arrangementFee - b.arrangementFee || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;
      case SortByEnum.DepositEquity:
        this.summarySearchResults.sort(
          (a, b) => a.equityOrDeposit - b.equityOrDeposit || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;
      default:
        if (!this.summarySearchResults) {
          return;
        }

        this.summarySearchResults.sort((a, b) => {
          if (a.netLoan < b.netLoan) return 1;
          if (a.netLoan > b.netLoan) return -1;

          if (a.trueMonthlyCost > b.trueMonthlyCost) return 1;
          if (a.trueMonthlyCost < b.trueMonthlyCost) return -1;

          return 0;
        });
        this.loanCriteria.sortBy = SortByEnum.NetLoanSize;
    }

    for (var i = 0; i < this.summarySearchResults.length; i++) {
      this.summarySearchResults[i].selectedRowNumber = i + 1;
    }
  }

  isFieldZero(fieldName) {
    if (this.loanCriteria) {
      const fieldValue = this.loanCriteria[fieldName];
      if (fieldValue == null || fieldValue === "0" || fieldValue === 0) {
        return true;
      }
    }

    return false;
  }

  submitLenderReferral() {
    this.loadingData = true;
    this.lenderReferralData.dealId = this.loanCriteria.id;
    this.dealClientClient
      .submitLenderReferral(this.lenderReferralData)
      .then((response) => {
        if (response) {
          this.displayMsg = "Your referral has been submitted.";
          this.showMsg = true;
          this.isLenderReferredSearch = true;
        } else {
          this.displayMsg = "Error while making a referral, please try later.";
          this.showMsg = true;
        }
      })
      .finally(() => {
        this.loadingData = false;
        this.lenderReferralData = null;
        sessionStorage.removeItem("lenderReferralReference");
      });
  }

  showBasedOnMainResidence() {
    return DealHelper.showBasedOnMainResidence(this.loanCriteria);
  }

  reloadPage() {
    if (this.reloadSearch) {
      window.location.reload();
    }
  }

  openRegisterModal() {
    if (window.self == window.top && this.$cookies.get("access_token")) {
      this.reloadSearch = true;
      this.reloadPage();
    } else {
      this.showRegisterModal = true;
    }
  }

  onEditSearchNameClick() {
    this.toggleEditSearchName = !this.toggleEditSearchName;
  }

  onSortbyClick() {
    //event.stopPropagation();
    this.closeFilterOptions();
    this.closeExportDropdown();
    this.showSortBy = !this.showSortBy;
  }

  onFilterClick() {
    // event.stopPropagation();
    this.closeSortByDropdown();
    this.closeExportDropdown();
    this.showFilters = !this.showFilters;
  }

  onExportClick() {
    this.prepareDataForShortlistPdf();
    this.closeSortByDropdown();
    this.closeFilterOptions();
    this.showExportOptions = !this.showExportOptions;
  }

  getSelectedSortByOptionText() {
    if (this.loanCriteria) {
      switch (this.loanCriteria.sortBy) {
        case SortByEnum.TrueMonthlyCost:
          return "True Monthly Cost";
        case SortByEnum.NetLoanSize:
          return "Net Loan Size";
        case SortByEnum.LenderCosts:
          return "Lender Costs (Est.)";
        case SortByEnum.LenderName:
          return "Lender Name (A-Z)";
        case SortByEnum.InterestRate:
          return "Interest Rate";
        case SortByEnum.ArrangementFee:
          return "Arrangement Fee";
        case SortByEnum.DepositEquity:
          return "Est. Deposit/Equity";
        case SortByEnum.ROCE:
          return "ROCE";
        default:
          return "";
      }
    } else {
      return "";
    }
  }

  createAccount() {
    this.dataLoading = true;
    this.enterpriseClient.orgUniqueRef = this.brokerageOrg?.uniqueRef;
    this.enterpriseClient.name = this.enterpriseClient.email;
    this.enterpriseClient.oidcId = this.enterpriseClient.email;
    this.userClient
      .registerEnterpriseUserAndSaveShortlisteResults({
        enterpriseUser: this.enterpriseClient,
        shortlistedResults: this.getDealLenders(this.comparisonList),
        password: this.password,
        dealUniqueRef: this.toggleEditSearchName ? this.loanCriteria.uniqueRef : "",
        newDealName: this.toggleEditSearchName ? this.loanCriteria.name : "",
      })
      .then((user) => {
        // clean up session storage
        if (window.self == window.top) {
          sessionStorage.removeItem("clientId");
          sessionStorage.removeItem("userRole");
        } else {
          this.organisationService.sendDataToParent("clientId", "");
          this.organisationService.sendDataToParent("userRole", "");
        }
        this.login("ENTERPRISE-LEAD-REGISTERED-FROM-RESULTS-PAGE", EventLogEnum.EnterpriseUserRegistration);
      })
      .catch((response) => {
        this.error = "Error while registering an account, please try again later.";
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  login(
    eventIdentifier: string = "ENTERPRISE-CONTACT-LOGGEDIN-FROM-RESULTS-PAGE",
    eventType: EventLogEnum = EventLogEnum.EnterpriseUserLogin,
  ) {
    this.dataLoading = true;
    if (!this.$cookies.get("access_token")) {
      this.$auth
        .newLogin(this.enterpriseClient.userName, this.password, "CC022EBE67BE0424EA2A6548B062D2D71")
        .then((response) => {
          this.error = "";
          let expiry: Date = response;

          this.eventLogClient.logEvent(
            eventIdentifier,
            eventType,
            this.loanCriteria.productType,
            this.loanCriteria.id,
            "",
            "",
            this.loanCriteria.dealClients[0]?.client.id,
          );

          this.$rootScope.$broadcast("login"); //tell everyone you have logged in
          if (eventType == EventLogEnum.EnterpriseUserRegistration)
            sessionStorage.setItem("showConfirmClientPhoneNo", "true");
          this.$location.path(`/bridgingresults/${this.loanCriteria.id}`);
        })
        .catch((response) => {
          this.isLoginError = true;
        })
        .finally(() => {
          this.dataLoading = false;
        });
    }
  }

  onClickLogin() {
    this.saveShortlistedLenders();
    this.login();
  }

  saveShortlistedLenders() {
    const shortlistDealLenders = this.getDealLenders(this.comparisonList);
    const shortlistRequest: ShortlistRequest = {
      dealLenders: shortlistDealLenders,
      commercialShortlistedResults: null,
      bridgingShortlistedResults: this.comparisonList,
      devFinanceShortlistedResults: null,
    } as ShortlistRequest;
    this.dealLenderClient.updateShortlistedLenders(shortlistRequest).then((response) => {});
  }

  returnShortlistedDealLenderStatusText(item: BridgingLenderResultSummaryDTO) {
    if (this.checkDeletedLender(item.lenderID, item.productID)) {
      return "Previously Deleted";
    }

    if (
      item.isDealLender &&
      this.loanCriteria.status != CaseStatusEnum.Search &&
      this.loanCriteria.status != CaseStatusEnum.NewCase &&
      this.loanCriteria.status != CaseStatusEnum.ReadyToSubmit
    ) {
      switch (item.dealLenderStatus) {
        case CaseLenderStateEnum.Shortlisted:
          return "Shortlisted";
        case CaseLenderStateEnum.Received:
          return "Awaiting DIP";
        case CaseLenderStateEnum.Offered:
          return "DIP Received";
        case CaseLenderStateEnum.Rejected:
          return "Lender Rejected";
        case CaseLenderStateEnum.Withdrawn:
          return "Lender Withdrawn";
        default:
          break;
      }
    }
  }

  isProceedButtonDisabled(): boolean {
    if (this.validateAllLendersUnique(this.comparisonList) == false) {
      return true;
    }

    const validLenders =
      this.comparisonList?.filter(
        (item) =>
          item.dealLenderStatus !== CaseLenderStateEnum.Rejected &&
          item.dealLenderStatus !== CaseLenderStateEnum.Withdrawn,
      ) || [];

    if (
      !validLenders ||
      validLenders.length < 1 ||
      validLenders.length > this.noOfShortlistAllowed ||
      this.isProceedClicked == true
    ) {
      return true;
    }

    return false;
  }

  onSaveClick() {
    if (this.isAssigned) {
      this.isSaveorSaveAsClicked = true;
      this.register(false, this.productResultList);
    } else {
      this.showShareSearchModal();
    }
  }

  getProductLastVerifiedDates(productIds: number[]) {
    this.productClient.getLastVerifiedDates(productIds).then((response) => {
      productIds.forEach((id) => {
        if (response[id] != null) {
          this.productLastVerifiedDates[id] = this.formatDate(response[id]);
        }
      });
    });
  }

  formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  validateAllLendersUnique(comparisonList: BridgingLenderResultSummaryDTO[]): boolean {
    if (this.isShortlistingMore) {
      const matchingItems = this.HiddenDealLenderList.filter((item1) =>
        this.comparisonList.some((item2) => item1.lenderId === item2.lenderID),
      );

      if (matchingItems.length > 0) return false;

      const numberOfUniqueLenderIds: number = new Set(this.comparisonList.map((item) => item.lenderID)).size;

      return numberOfUniqueLenderIds == this.comparisonList.length;
    }

    return true;
  }

  /**Closes all context menus */
  closeContextMenus() {
    var myevent = event;
    this.closeFilterOptions();
    this.closeSortByDropdown();
  }

  closeFilterOptions() {
    this.showFilters = false;
  }

  closeSortByDropdown() {
    this.showSortBy = false;
  }

  closeExportDropdown() {
    this.showExportOptions = false;
  }

  updateClientContactInfoAndNotifyBroker() {
    if (this.loanCriteria != null && this.loanCriteria.dealClients != null) {
      this.dealClientClient
        .updateClientContactInfoAndNotifyBroker(
          this.clientUpdatedContact,
          this.loanCriteria?.id,
          this.loanCriteria.dealClients[0].client.id,
        )
        .then((response) => {
          this.showClientPhoneNumberConfirmationModal = false;
          this.sliderShown = true;
        })
        .catch((response) => {
          this.error = "There was an error updating the contact. Please try again later.";
        })
        .finally(() => {
          sessionStorage.removeItem("showConfirmClientPhoneNo");
        });
    } else {
      sessionStorage.removeItem("showConfirmClientPhoneNo");
      this.showClientPhoneNumberConfirmationModal = false;
      this.sliderShown = true;
    }
  }

  getOrgName() {
    if (this.orgName) {
      return this.orgName.replace(/_/g, " ");
    }
    return "";
  }

  /**Sends an email to the email address for the user to reset their password */
  sendResetPasswordEmail() {
    this.loadingData = true;
    this.userClient
      .resetForgottenPassword(this.enterpriseClient.email)
      .then((response) => {
        this.isLoginError = false;
        this.isResetPasswordSubmitted = true;
        this.registrationLoginError = null;
      })
      .catch((error) => {
        this.registrationLoginError = "There was an error sending the password reset email. Please try again later.";
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  getRequiredRolesOptions() {
    return DealHelper.getRequiredRolesOptions();
  }

  validateAccessAndRedirect() {
    //Do not allow the connect user to access the deal
    if (this.loanCriteria && this.loanCriteria.isReferredToConnect && this.isConnectUser) {
      this.$location.path(`/bridgingcasedashboard/${this.loanCriteria.id}`);
    } else {
      if (
        this.loanCriteria &&
        this.loanCriteria.status != CaseStatusEnum.NewCase &&
        this.loanCriteria.status != CaseStatusEnum.Search &&
        !this.isShortlistingMore
      ) {
        this.dealLenderClient.fetchDealLendersByDealId(this.loanCriteria.id).then((results) => {
          if (
            results &&
            results.filter(
              (dl) =>
                !dl.isDeleted &&
                dl.status != CaseLenderStateEnum.Withdrawn &&
                dl.status != CaseLenderStateEnum.Rejected,
            ).length >= 5 &&
            results.filter((dl) => !dl.isDeleted && dl.isBidAccepted)
          ) {
            if (this.isAdmin || this.isBroker) {
              this.$location.path("/dealforum/" + this.loanCriteria.id);
            } else {
              this.$location.path(`/userdashboard`);
            }
          } else {
            this.$location.path(`/bridgingshortlistmore/${this.loanCriteria.id}`);
          }
        });
      }
    }
  }
}
